






import { Component, Prop, Vue } from "vue-property-decorator";
import { State, Getter, Action, Mutation, namespace } from "vuex-class";
const setting = namespace("setting");

@Component({})
export default class ShowInvoice extends Vue {
  @setting.State serviceMode;
  // MODE_S(1,"标准模式"),
  // MODE_A(2,"快捷模式 A"),
  // MODE_B(3,"快捷模式 B")

  // settlementStatus 0 未结算，1 已结算
  // invoicingStatus 0 未开票，1 已开票
  // invoicingRequire 1 需要开票 0 不需要开票
  // orderSource 1: 到店 2：天猫 3：小程序
  @Prop({ default: () => ({}) })
  orderData: any;
  get $show() {
    if (this.orderData.orderSource === "2") {
      // 天猫渠道
      if (this.orderData.orderStatus === "4" && this.orderData.invoicingStatus === "0") {
        return true;
      }
    } else {
      if (this.orderData.settlementStatus === "1" && this.orderData.invoicingStatus === "0") {
        return true;
      }
    }
    return false;
  }
}
